import React from 'react'
import AuthenticatedImage from './AuthenticatedImage'

function ImageThumbnail({ imageId, ...restProps }) {
  const source = `/images/thumbnail/${imageId}`
  return <AuthenticatedImage source={source} {...restProps} />
}

export default ImageThumbnail



// WEBPACK FOOTER //
// ./src/components/ImageThumbnail.js